import { ChangeEvent } from "react";
import { AdminLeadControllerGetAllResponse } from "service";
import { FilterState, UpdateFilter } from "../hooks/useLeadsFilters";

export const handleLeadCheckboxChange = (
  evt: ChangeEvent<HTMLInputElement>,
  leadId: string,
  updateFilter: UpdateFilter,
) => {
  updateFilter("selectedLeadIds", (filters: FilterState) => {
    if (evt.target.checked) {
      return {
        ...filters,
        selectedLeadIds: filters.selectedLeadIds.includes(leadId)
          ? filters.selectedLeadIds
          : [...filters.selectedLeadIds, leadId],
      };
    }
    return {
      ...filters,
      selectedLeadIds: filters.selectedLeadIds.filter((id) => id !== leadId),
    };
  });
};

export const handleLeadCheckboxChangeForAll = (
  evt: ChangeEvent<HTMLInputElement>,
  updateFilter: UpdateFilter,
  data: AdminLeadControllerGetAllResponse | undefined,
) => {
  updateFilter(
    "selectedLeadIds",
    evt.target.checked ? (data?.data || []).map((lead) => lead.id) : [],
  );
};
